/**
 * The Aelo tab in a Bitrix24 CRM card (#745): `/embedded/crm-tab?entityType=&entityId=`.
 * Bitrix24 opens it through `/api/v1/embedded/app` with the card's placement;
 * the screen is `-CrmTabScreen.tsx`. Spec: docs/plans/2026-10-17-bitrix24-deal-tab.md §4.4.
 */
import { createFileRoute } from '@tanstack/react-router';
import { CrmTabScreen } from './-CrmTabScreen';
import { parseCrmTabSearch, requireCrmTabEntity } from './-crm-tab-search';

function CrmTabRoute() {
  const { entityType, entityId } = Route.useSearch();
  // `beforeLoad` has sent an address without a readable card to the dashboard.
  if (!entityType || !entityId) return null;
  // Keyed by the card: another card is another screen, with nothing carried over.
  return (
    <CrmTabScreen
      key={`${entityType}:${entityId}`}
      entityType={entityType}
      entityId={entityId}
    />
  );
}

export const Route = createFileRoute('/embedded/crm-tab/')({
  validateSearch: parseCrmTabSearch,
  beforeLoad: requireCrmTabEntity,
  component: CrmTabRoute,
});
